export const getFedopsInteractionName =
  (editorType: string) => (interactionName: string) =>
    `NewDynamicPages_${editorType.toLowerCase()}/${interactionName}`
